export default "__VITE_ASSET__CYvs5v8S__"